import React from 'react'

import computer from '../../../assets/computer-with-checklist.svg'

import Card from '../../components/Card'
import Skills from '../../containers/Skills'
import SkillsHeading from '../../components/SkillsHeading'
import SkillsForm from '../../components/SkillsForm'
import SkeletonSkillsScene from '../../skeletons/SkeletonSkillsScene'

const SkillsScene = () => (
  <Skills>
    {props => (
      <Card title="Top skills" imageUrl={computer} width={550}>
        <SkillsHeading />

        <Choose>
          <When condition={props.loading}>
            <SkeletonSkillsScene />
          </When>

          <Otherwise>
            <SkillsForm
              searching={props.searching}
              searchSkills={props.searchSkills}
              searchResults={props.searchResults}
              updateSkills={props.updateSkills}
              selectedSkillsCount={props.selectedSkillsCount}
              initialValues={{ skills: props.skillsList }}
              clearErrors={props.clearErrors}
              goToNextStep={props.goToNextStep}
              trackRemovedSkill={props.trackRemovedSkill}
            />
          </Otherwise>
        </Choose>
      </Card>
    )}
  </Skills>
)

export default SkillsScene
